"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  SPINS_API: 'SPINS_API',
  MERCH_RECOMMEND_API: 'MERCH_RECOMMEND_API'
};